import {DropdownMenu, type IconName} from '@wandb/components';
import React, {type ReactNode} from 'react';

type MenuItemProps = {
  children: ReactNode;
  icon?: IconName;
  onAction?: () => void;
};

export function MenuItem({children, icon, onAction}: MenuItemProps) {
  return (
    <DropdownMenu.Item onAction={onAction}>
      {icon ? <DropdownMenu.ItemDecorationLeft iconProps={{icon}} /> : null}
      <DropdownMenu.ItemLabel>{children}</DropdownMenu.ItemLabel>
    </DropdownMenu.Item>
  );
}
